import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import * as yup from 'yup';
import { toast } from 'react-toastify';

import DefaultChangeForm from './DefaultChangeForm';
import { editBulkDefault } from '../../../../../../general_redux/rates/actions';
import { getTheMaximumNumberOfNightsAllowed } from '../../../../../../common/functions/utils';
import styles from '../../../Rentals/rentals.module.css';

function BulkDefaultChange(props) {

  const dispatch = useDispatch();

  const numberOfNights = 730; // maximum number of days accepted by the backend

  const schemaDefaultRate = yup.object({
    multiRentals: yup.array().test('minLength', 'Rental selection is required', value => value && value.length > 0),
    dailyRate: yup.number().test('dailyRate', 'Must be a positive number', function(value) { return ((this.parent.checkDailyRate && value >= 0) || (!this.parent.checkDailyRate)) ? true : false }).typeError('Must be a number value'),
    minimumStayRequirement: yup.number()
      .test('minimumStayRequirement', 'Must be an integer greater than or equal to 1', function(value) { return ((this.parent.checkMinimumStayRequirement && value >= 1) || (!this.parent.checkMinimumStayRequirement)) ? true : false })
      .test("", "", function(value) { return (1 > value || value > numberOfNights) ? false : true })
      .max(numberOfNights, `Must be an integer less than or equal to ${numberOfNights}`)
      .integer('Must be an integer number')
      .typeError('Must be a number value'),
    maximumStayRequirement: yup.number()
      .test('maximumStayRequirement', 'Must be an integer greater than or equal to 1', function(value) { return ((this.parent.checkMaximumStayRequirement && value >= 1) || (!this.parent.checkMaximumStayRequirement)) ? true : false })
      .test("", "", function(value) { return (1 > value || value > numberOfNights) ? false : true })
      .max(numberOfNights, `Must be an integer less than or equal to ${numberOfNights}`)
      .integer('Must be an integer number')
      .typeError('Must be a number value'),
    blockDateBefore: yup.number().test('blockDateBefore', 'Must be a positive number', function(value) { return ((this.parent.checkBlockDateBefore && value >= 0) || (!this.parent.checkBlockDateBefore)) ? true : false }).integer('Must be an integer number').typeError('Must be a number value'),
    blockDateAfter: yup.number().test('blockDateAfter', 'Must be a positive number', function(value) { return ((this.parent.checkBlockDateAfter && value >= 0) || (!this.parent.checkBlockDateAfter)) ? true : false }).integer('Must be an integer number').typeError('Must be a number value'),
  });

  const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);

  const handleSubmit = (data, selectedData) => {

    const payloadMapper = {
      dailyRate: data.dailyRate && Number(data.dailyRate),
      minimumStayRequirement: data.minimumStayRequirement && Number(data.minimumStayRequirement),
      maximumStayRequirement: data.maximumStayRequirement && Number(data.maximumStayRequirement),
      blockDateBefore: data.blockDateBefore && Number(data.blockDateBefore),
      blockDateAfter: data.blockDateAfter && Number(data.blockDateAfter),
    };

    const selectedFields = {};

    Object.keys(payloadMapper).forEach((field)=> {

        const fieldValue = payloadMapper[field];
        const check = `check${field.charAt(0).toUpperCase()}${field.slice(1)}`;

        if (fieldValue != undefined && data[check]) {
            selectedFields[field] = fieldValue;
        };
    });

    const payload = [];
    selectedData.forEach((rental) => {
      if (rental.value === "default") {
        payload.push({
          default:{
            ...selectedFields,
          }
        })
      } else {
        payload.push({
          rentalId: Number(rental.value),
          ...selectedFields,
        })
      };
    });
    // console.log(payload);
    dispatch(editBulkDefault(payload));
    props.onHide();
  };

  const getOptions= ()=>{
    const tmp=[];
    tmp.push({
      value: "default",
      label:"New Rentals"
    });
    rentals.map((row) => (tmp.push({ value: row.id, label: row.name })));
    return tmp;
  }
  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className={styles.modalTitle}>Set default rates and rules</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.deleteModalBody}>
        <DefaultChangeForm
          schema={schemaDefaultRate}
          handleSubmit={handleSubmit}
          options={getOptions()}
          onHide={props.onHide}
          initValue = {props.initValue}
        />
      </Modal.Body>
    </Modal>
  );
}
export default BulkDefaultChange;
